import axios from 'axios';
import qs from 'qs';
import humps from 'humps';
import _ from 'lodash';
import { createAction } from 'redux-actions';
import { FETCH_JOB_STATUS, FETCH_LATEST_JOB_STATUS } from 'src/constants/EndpointUrls';
import { setGlobalErrors } from 'src/reducers/global';
import { INITIAL_POLLING_INTERVAL, MAX_POLLING_INTERVAL } from 'src/constants/Generals';
import { fetchBonusOptions } from 'src/reducers/searchForm';
import { fetchEmployeeBonus, getEmployeeBonusQueries } from 'src/reducers/employees/employeeBonus';

const SET_STATUS = 'SET_STATUS/SET_STATUS';
export const setStatus = createAction(SET_STATUS);

export const REPORT_BONUS_JOB_NAME = 'report_employee_bonus_job';
export const REDUCER_NAME = 'jobStatus';
export const isJobSuccess = jobState => jobState === 'success';
export const isJobIncomplete = jobState => ['waiting', 'in_progress'].includes(jobState);
export const getJob = state => _.get(state, 'JobStatus');

export const fetchJobStatus = searchParams => async (dispatch, getState) => {
  try {
    const query = qs.stringify(humps.decamelizeKeys(searchParams), { arrayFormat: 'brackets' });
    const state = getState();
    const jobStatusHash = state.JobStatus;
    await axios
      .get(`${FETCH_JOB_STATUS}?${query}`)
      .then(response => {
        jobStatusHash[searchParams.job_name] = response.data.payload.jobStatus;
        dispatch(setStatus(jobStatusHash));
      })
      .catch(response => {
        // ステータスが不明なので、ステータスを期待する各処理が動作しないように無効な値をセットする
        jobStatusHash[searchParams.job_name] = {};
        dispatch(setStatus(jobStatusHash));
        if (response.response.status !== 404) {
          dispatch(setGlobalErrors('エラーが発生しました。'));
        }
      });
  } catch (err) {
    dispatch(setGlobalErrors('エラーが発生しました。'));
  }
};

export const fetchConfirmJobStatus = (
  interval = INITIAL_POLLING_INTERVAL,
  searchParams = { job_name: 'confirmClientBonusJob', search_params: { visible: true } }
) => async (dispatch, getState) => {
  try {
    const query = qs.stringify(humps.decamelizeKeys(searchParams), { arrayFormat: 'brackets' });
    const state = getState();
    const jobStatusHash = state.JobStatus;
    await axios
      .get(`${FETCH_LATEST_JOB_STATUS}?${query}`)
      .then(response => {
        jobStatusHash[searchParams.job_name] = response.data.payload.jobStatus;
        if (_.includes(['waiting', 'in_progress'], _.get(response.data.payload.jobStatus, 'status'))) {
          const nextInterval = MAX_POLLING_INTERVAL > interval ? interval * 2 : interval;
          setTimeout(() => {
            dispatch(fetchConfirmJobStatus(nextInterval, searchParams));
          }, nextInterval);
        } else {
          dispatch(setStatus(jobStatusHash));
          dispatch(fetchBonusOptions());
          dispatch(fetchEmployeeBonus(getEmployeeBonusQueries(getState())));
        }
      })
      .catch(response => {
        // ステータスが不明なので、ステータスを期待する各処理が動作しないように無効な値をセットする
        jobStatusHash[searchParams.job_name] = {};
        if (response.response.status !== 404) {
          dispatch(setGlobalErrors('エラーが発生しました。'));
        }
      });
  } catch (err) {
    dispatch(setGlobalErrors('エラーが発生しました。'));
  }
};

export const INITIAL_STATE = {
  report_employee_bonus_job: {},
  export_employee_data_job: {},
  confirmClientBonusJob: {},
  exportWageLedgerJob: {},
  exportWithholdingReportPdfJob: {}
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_STATUS:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};
